import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-GFLD98NX15";
const PRODUCTION_HOSTS = new Set([
  "jilu.io",
  "www.jilu.io",
  "jiluio.netlify.app",
]);

declare global {
  interface Window {
    gtag?: (
      command: "config" | "event" | "js",
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
  }
}

const AnalyticsPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (!PRODUCTION_HOSTS.has(window.location.hostname)) return;
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsPageView;
